import PropTypes from 'prop-types'
import { cn } from '@tiptap-ui/lib/tiptap-utils'
import '@tiptap-ui/components/tiptap-ui-primitive/input/input.scss'

function Input ({
  className,
  type,
  ...props
}) {
  return (<input type={type} className={cn('tiptap-input', className)} {...props} />)
}

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
}

function InputGroup ({
  className,
  children,
  ...props
}) {
  return (
    <div className={cn('tiptap-input-group', className)} {...props}>
      {children}
    </div>
  )
}

InputGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export { Input, InputGroup }
